export const normalizeIndicator = indictor => indictor.replace(/\\/g, ' ');
